module.exports = __webpack_public_path__ + "static/media/hari.b97a384c.jpg";